
export default {
  staticDomain: '//static.hsappstatic.net' || window.location.host,
  staticDomainPrefix: '//static.hsappstatic.net' || ('//' + window.location.host),
  currentProject: 'embedded-viral-link-ui',
  currentProjectVersion: 'static-1.6631',
  depVersions: {
  "embedded-viral-link-ui": "static-1.6631",
  "head-dlb": "static-1.5007",
  "hs-test-utils": "static-1.8230",
  "hubspot-dlb": "static-2.1854",
  "HubStyleTokens": "static-2.11681",
  "I18n": "static-7.1650",
  "jasmine-runner": "static-1.6660",
  "quartz": "static-1.7304",
  "quartz-core": "static-1.6523",
  "react-dlb": "static-1.83",
  "reselect": "static-3.8",
  "webpack-env": "static-1.54",
  "cssUtils": "static-1.854",
  "enviro": "static-4.455",
  "foundations-components": "static-1.8315",
  "hub-http": "static-1.6424",
  "hubspot-url-utils": "static-1.4132",
  "HubStyle": "static-2.11988",
  "icons": "static-2.668",
  "immer": "static-1.33",
  "laboratory-lib": "static-3.7358",
  "PortalIdParser": "static-2.404",
  "quartz-config": "static-1.1082",
  "quartz-routing": "static-1.734",
  "quick-fetch": "static-1.4061",
  "react": "static-7.189",
  "react-dom": "static-7.85",
  "react-input-autosize": "static-2.17",
  "react-redux": "static-7.71",
  "react-rhumb": "static-1.16910",
  "react-select-plus": "static-1.108",
  "react-utils": "static-2.5484",
  "react-virtualized": "static-2.102",
  "redux": "static-4.16",
  "redux-thunk": "static-2.43",
  "redux-toolkit": "static-1.7",
  "signup-constants": "static-1.19382",
  "signup-ui-lego-core": "static-1.21392",
  "styled-components": "static-2.89",
  "StyleGuideUI": "static-3.491",
  "ui-addon-react-router-dom": "static-1.9739",
  "ui-images": "static-2.1215",
  "UIComponents": "static-3.8627",
  "usage-tracker": "static-1-session-replay-endpoint-migration.6",
  "usage-tracker-core": "static-1-session-replay-endpoint-migration.6",
  "viral-links-lib": "static-1.7277",
  "hs-promise-rejection-tracking": "static-1.5587",
  "raven": "static-3.5925",
  "raven-hubspot": "static-1.6232",
  "classnames": "static-2.10",
  "hoist-non-react-statics": "static-3.9",
  "immutable": "static-2.79",
  "metrics-js": "static-1.9637",
  "bend-plugin-trellis-migration": "static-1.3543",
  "moment": "static-3.26",
  "bend-plugin-quartz": "static-1.3581",
  "quartz-webpack": "static-1.3528",
  "bend-plugin-quartz-routing": "static-1.382",
  "HeadJS": "static-2.782",
  "framer-motion": "static-1.75",
  "hs-test-utils-bend-plugin": "static-1.3341",
  "msw": "static-1.39",
  "testing-library": "static-1.155",
  "foundations-theming": "static-1.4650",
  "i18n-data": "static-1.225",
  "moment-timezone": "static-5.86",
  "jasmine": "static-4.4530",
  "dispatcher": "static-1.140",
  "general-store": "static-6.20",
  "hub-http-janus": "static-1.858",
  "hubspotter-http": "static-1.4795",
  "mobile-manifest-mixins": "static-1.555",
  "module-federation": "static-1.29",
  "quartz-auth": "static-1.979",
  "quartz-head": "static-1.969",
  "quartz-i18n": "static-1.979",
  "quartz-test": "static-1.979",
  "quartz-tracking": "static-1.683",
  "trellis-components": "static-1.2370",
  "ui-fonts": "static-1.943",
  "usage-tracker-container": "static-1-session-replay-endpoint-migration.6",
  "sassPrefix": "static-1.160",
  "bend-plugin-foundations-components": "static-1.4584",
  "floating-ui": "static-1.60",
  "foundations-assets": "static-1.5082",
  "foundations-theming-specialty": "static-1.2366",
  "hs-story-utils": "static-1.9632",
  "react-aria": "static-1.69",
  "react-create-root-preference": "static-1.50",
  "tanstack-table": "static-1.58",
  "trellis-assets": "static-1.2351",
  "hs-locale-management": "static-1.225",
  "superstore": "static-1.4965",
  "csstype": "static-1.50",
  "web-vitals": "static-1.9",
  "rpc-client-utils": "static-1.4865",
  "emoji-regex": "static-1.7",
  "PatternValidationJS": "static-1.3103",
  "signup-ui-url-generator": "static-2.8263",
  "bender-build-tools": "static-1.3323",
  "bend-plugin-foundations-theming": "static-1.3133",
  "foundations-theming-base": "static-1.3635",
  "stylex": "static-1.37",
  "hub-http-shared-msw-handlers": "static-1.10452",
  "hubspotter-http-shared-msw-handlers": "static-1.10450",
  "usage-tracker-session-replay": "static-1-session-replay-endpoint-migration.6",
  "base-ui": "static-1.17",
  "react-day-picker": "static-1.6",
  "trellis-theming": "static-1.1159",
  "tanstack-virtual": "static-1.33",
  "bend-plugin-chirp-manifest": "static-1.275",
  "chirp-fetch": "static-1.2094",
  "amplitude-session-replay-browser": "static-1.60",
  "ts-schema": "static-1.4224"
},
  depPathPrefixes: {
  "embedded-viral-link-ui": "/embedded-viral-link-ui/static-1.6631",
  "head-dlb": "/head-dlb/static-1.5007",
  "hs-test-utils": "/hs-test-utils/static-1.8230",
  "hubspot-dlb": "/hubspot-dlb/static-2.1854",
  "HubStyleTokens": "/HubStyleTokens/static-2.11681",
  "I18n": "/I18n/static-7.1650",
  "jasmine-runner": "/jasmine-runner/static-1.6660",
  "quartz": "/quartz/static-1.7304",
  "quartz-core": "/quartz-core/static-1.6523",
  "react-dlb": "/react-dlb/static-1.83",
  "reselect": "/reselect/static-3.8",
  "webpack-env": "/webpack-env/static-1.54",
  "cssUtils": "/cssUtils/static-1.854",
  "enviro": "/enviro/static-4.455",
  "foundations-components": "/foundations-components/static-1.8315",
  "hub-http": "/hub-http/static-1.6424",
  "hubspot-url-utils": "/hubspot-url-utils/static-1.4132",
  "HubStyle": "/HubStyle/static-2.11988",
  "icons": "/icons/static-2.668",
  "immer": "/immer/static-1.33",
  "laboratory-lib": "/laboratory-lib/static-3.7358",
  "PortalIdParser": "/PortalIdParser/static-2.404",
  "quartz-config": "/quartz-config/static-1.1082",
  "quartz-routing": "/quartz-routing/static-1.734",
  "quick-fetch": "/quick-fetch/static-1.4061",
  "react": "/react/static-7.189",
  "react-dom": "/react-dom/static-7.85",
  "react-input-autosize": "/react-input-autosize/static-2.17",
  "react-redux": "/react-redux/static-7.71",
  "react-rhumb": "/react-rhumb/static-1.16910",
  "react-select-plus": "/react-select-plus/static-1.108",
  "react-utils": "/react-utils/static-2.5484",
  "react-virtualized": "/react-virtualized/static-2.102",
  "redux": "/redux/static-4.16",
  "redux-thunk": "/redux-thunk/static-2.43",
  "redux-toolkit": "/redux-toolkit/static-1.7",
  "signup-constants": "/signup-constants/static-1.19382",
  "signup-ui-lego-core": "/signup-ui-lego-core/static-1.21392",
  "styled-components": "/styled-components/static-2.89",
  "StyleGuideUI": "/StyleGuideUI/static-3.491",
  "ui-addon-react-router-dom": "/ui-addon-react-router-dom/static-1.9739",
  "ui-images": "/ui-images/static-2.1215",
  "UIComponents": "/UIComponents/static-3.8627",
  "usage-tracker": "/usage-tracker/static-1-session-replay-endpoint-migration.6",
  "usage-tracker-core": "/usage-tracker-core/static-1-session-replay-endpoint-migration.6",
  "viral-links-lib": "/viral-links-lib/static-1.7277",
  "hs-promise-rejection-tracking": "/hs-promise-rejection-tracking/static-1.5587",
  "raven": "/raven/static-3.5925",
  "raven-hubspot": "/raven-hubspot/static-1.6232",
  "classnames": "/classnames/static-2.10",
  "hoist-non-react-statics": "/hoist-non-react-statics/static-3.9",
  "immutable": "/immutable/static-2.79",
  "metrics-js": "/metrics-js/static-1.9637",
  "bend-plugin-trellis-migration": "/bend-plugin-trellis-migration/static-1.3543",
  "moment": "/moment/static-3.26",
  "bend-plugin-quartz": "/bend-plugin-quartz/static-1.3581",
  "quartz-webpack": "/quartz-webpack/static-1.3528",
  "bend-plugin-quartz-routing": "/bend-plugin-quartz-routing/static-1.382",
  "HeadJS": "/HeadJS/static-2.782",
  "framer-motion": "/framer-motion/static-1.75",
  "hs-test-utils-bend-plugin": "/hs-test-utils-bend-plugin/static-1.3341",
  "msw": "/msw/static-1.39",
  "testing-library": "/testing-library/static-1.155",
  "foundations-theming": "/foundations-theming/static-1.4650",
  "i18n-data": "/i18n-data/static-1.225",
  "moment-timezone": "/moment-timezone/static-5.86",
  "jasmine": "/jasmine/static-4.4530",
  "dispatcher": "/dispatcher/static-1.140",
  "general-store": "/general-store/static-6.20",
  "hub-http-janus": "/hub-http-janus/static-1.858",
  "hubspotter-http": "/hubspotter-http/static-1.4795",
  "mobile-manifest-mixins": "/mobile-manifest-mixins/static-1.555",
  "module-federation": "/module-federation/static-1.29",
  "quartz-auth": "/quartz-auth/static-1.979",
  "quartz-head": "/quartz-head/static-1.969",
  "quartz-i18n": "/quartz-i18n/static-1.979",
  "quartz-test": "/quartz-test/static-1.979",
  "quartz-tracking": "/quartz-tracking/static-1.683",
  "trellis-components": "/trellis-components/static-1.2370",
  "ui-fonts": "/ui-fonts/static-1.943",
  "usage-tracker-container": "/usage-tracker-container/static-1-session-replay-endpoint-migration.6",
  "sassPrefix": "/sassPrefix/static-1.160",
  "bend-plugin-foundations-components": "/bend-plugin-foundations-components/static-1.4584",
  "floating-ui": "/floating-ui/static-1.60",
  "foundations-assets": "/foundations-assets/static-1.5082",
  "foundations-theming-specialty": "/foundations-theming-specialty/static-1.2366",
  "hs-story-utils": "/hs-story-utils/static-1.9632",
  "react-aria": "/react-aria/static-1.69",
  "react-create-root-preference": "/react-create-root-preference/static-1.50",
  "tanstack-table": "/tanstack-table/static-1.58",
  "trellis-assets": "/trellis-assets/static-1.2351",
  "hs-locale-management": "/hs-locale-management/static-1.225",
  "superstore": "/superstore/static-1.4965",
  "csstype": "/csstype/static-1.50",
  "web-vitals": "/web-vitals/static-1.9",
  "rpc-client-utils": "/rpc-client-utils/static-1.4865",
  "emoji-regex": "/emoji-regex/static-1.7",
  "PatternValidationJS": "/PatternValidationJS/static-1.3103",
  "signup-ui-url-generator": "/signup-ui-url-generator/static-2.8263",
  "bender-build-tools": "/bender-build-tools/static-1.3323",
  "bend-plugin-foundations-theming": "/bend-plugin-foundations-theming/static-1.3133",
  "foundations-theming-base": "/foundations-theming-base/static-1.3635",
  "stylex": "/stylex/static-1.37",
  "hub-http-shared-msw-handlers": "/hub-http-shared-msw-handlers/static-1.10452",
  "hubspotter-http-shared-msw-handlers": "/hubspotter-http-shared-msw-handlers/static-1.10450",
  "usage-tracker-session-replay": "/usage-tracker-session-replay/static-1-session-replay-endpoint-migration.6",
  "base-ui": "/base-ui/static-1.17",
  "react-day-picker": "/react-day-picker/static-1.6",
  "trellis-theming": "/trellis-theming/static-1.1159",
  "tanstack-virtual": "/tanstack-virtual/static-1.33",
  "bend-plugin-chirp-manifest": "/bend-plugin-chirp-manifest/static-1.275",
  "chirp-fetch": "/chirp-fetch/static-1.2094",
  "amplitude-session-replay-browser": "/amplitude-session-replay-browser/static-1.60",
  "ts-schema": "/ts-schema/static-1.4224"
}
};
